import { ValidationError } from 'yup';

// TODO improve types for acc
export const getFormErrors = (errors: ValidationError): Record<string, string> => {
  return errors.inner.reduce((acc: Record<string, string>, err: ValidationError) => {
    const { path, message } = err;
    return { ...acc, [path as string]: message };
  }, {});
};
